import { Button, Modal } from "antd";

interface Props {
  title: string;
  desc: string;
  onOk: () => void;
  open: boolean;
}
const SuccessfulModal = (props: Props) => {
  const { title, desc, onOk, open } = props;

  return (
    <Modal title={title} open={open} onOk={onOk} onCancel={onOk}
    footer={[<Button key="ok" type="primary"  onClick={onOk}>
    Ok
  </Button>,]}>
      <p>{desc}</p>
    </Modal>
  );
};

export default SuccessfulModal;
